/**
Configuration (in db) must follow example (if default missing, first item of languages will be considered as the default language) =>
{
	"app": "7NOW",
	"type": "global",
	"configurations": [{
        "feature": "NOT USED",
        "properties": [{
            "id": "language",
            "default_value": {
                "default": "en",
                "languages": [
                    {"code": "en"},
                    {"code": "ja"},
                    {"code": "vi"},
                    {"code": "he", "rtl": true}
                ]
            }
        }]
    }]
}
 */

import _ from 'lodash'
import config from '../../common/config'

import retrieveLanguage from './retrieveLanguage'

export const frontDefaultLanguage = ['en','ja']
const stringsData = {}
const emptyHandler = {
    get: function (target, name) {
        return target.hasOwnProperty(name) ? target[name] : `{${name}}`
    },
}
export const strings = new Proxy(_.clone(stringsData), emptyHandler)

export let languages = frontDefaultLanguage
export let language = frontDefaultLanguage
export let rtl = false
let defaultLanguage = frontDefaultLanguage

export async function setAvailableLanguages(newLanguages) {
    const tmpDefaultLanguage = newLanguages.default
    const tmpLanguages = newLanguages.languages

    if (
        tmpDefaultLanguage &&
    tmpLanguages.some(lang => lang.code === tmpDefaultLanguage)
    )
        defaultLanguage = tmpDefaultLanguage
    else defaultLanguage = tmpLanguages[0].code

    languages = tmpLanguages
}

export async function loadLanguage({
    queryLanguage,
    localStorageLanguage,
    forcedLanguage,
}) {
    let newLanguage = forcedLanguage
    const { isLanguageChangeEnabled } = config
    if(isLanguageChangeEnabled === 'false'){
        newLanguage = defaultLanguage
    }
    else if (!newLanguage) {
        newLanguage = queryLanguage
        if (!languages.some(lang => lang.code === queryLanguage)) {
            newLanguage = localStorageLanguage
            if (!languages.some(lang => lang.code === localStorageLanguage))
                newLanguage = defaultLanguage
        }
    }

    let content = await retrieveLanguage({
        component: 'delivery',
        app: 'lvt',
        platform: 'ui',
        language: newLanguage,
    })

    Object.assign(strings, content)
    language = newLanguage
    rtl = languages.find(l => l.code === newLanguage).rtl || false
    return newLanguage
}